module.exports = "/images/ny-street-5.jpg";